import {changePageTitle, setAlert} from "../redux/actions";
import {StateService} from "./state.service";
import CustomTextField from "../custom-text-field/custom-text-field";
import CustomButton from "../custom-button/custom-button";
import CustomButtonGroup from "../custom-button-group/custom-button-group";
import {State} from "./state";
import {FormEvent, useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import React from "react";

interface StateDetailProps {
    id?: number | null;
    dialog?: boolean;
    onClose?: (state?: State) => void;
}

export function StateDetail({id, dialog, onClose}: StateDetailProps) {

    const [item, setItem] = useState(StateService.createState());
    const dispatch = useDispatch();

    const findOne = useCallback(async (id: number) => {
        const result = await StateService.findOne(id);
        setItem(result);
    }, []);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Estado " + id : "Novo estado"));
        }
        if (id) {
            findOne(id).then();
        }
    }, [id, dialog]); // eslint-disable-line react-hooks/exhaustive-deps

    const save = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        StateService.save(item).then((result) => {
            if (onClose) {
                onClose(result.data);
            }
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao salvar registro - ' + error.message,
                severity: 'error'
            }));
        })
    }

    const cancel = () => {
        if (onClose) {
            onClose();
        }
    }

    const setDescricao = (event: React.ChangeEvent<HTMLInputElement>) => {
        setItem({
            ...item,
            descricao: event.target.value
        })
    }

    const setSigla = (event: React.ChangeEvent<HTMLInputElement>) => {
        setItem({
            ...item,
            sigla: event.target.value
        })
    }

    return (
        <form onSubmit={save}>
            <CustomTextField fullWidth autoFocus required label="Descrição" value={item.descricao}
                             onChange={setDescricao}/>
            <CustomTextField fullWidth required label="Sigla" value={item.sigla} onChange={setSigla}/>
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )

}